export class XmlDetailsHelper {
    private static FONT_FAMILY = 'font-family';
    private static FONT_SIZE = 'font-size';
    private static COLOR = 'color';

    private static get styles(): Array<string> {
        return [this.FONT_FAMILY, this.FONT_SIZE, this.COLOR];
    }

    public static isLinesStylesDifferent(line1: Element | null, line2: Element | null): boolean {
        if (!line1 || !line2) {
            return true;
        }

        const line1Styles = this.extractLineStyles(line1);
        const line2Styles = this.extractLineStyles(line2);

        if (line1Styles.size === 0 || line2Styles.size === 0) {
            return true;
        }

        for (let style of this.styles) {
            const line1Style = line1Styles.get(style);
            const line2Style = line2Styles.get(style);

            const isStylesDifferent = this.isStyleDifferent(line1Style, line2Style, style);

            if (isStylesDifferent) {
                return true;
            }
        }

        return false;
    }

    private static isStyleDifferent(style1: string | undefined, style2: string | undefined, styleKey: string): boolean {
        if (!style1 || !style2) {
            return true;
        }

        if (styleKey === this.FONT_SIZE) {
            return this.isFontSizeDifferent(style1, style2);
        }

        return style1 !== style2;
    }

    private static isFontSizeDifferent(fontSize1: string, fontSize2: string): boolean {
        const fontSize1Number = Number(fontSize1);
        const fontSize2Number = Number(fontSize2);

        if (Number.isNaN(fontSize1Number) || Number.isNaN(fontSize2Number)) {
            return true;
        }

        return Math.abs(fontSize1Number - fontSize2Number) > 0.75;
    }

    private static extractLineStyles(line: Element | null): Map<string, string> {
        const result: Map<string, string> = new Map();

        if (!line) {
            return result;
        }

        const styleAttr = line.getAttribute('style');

        if (!styleAttr) {
            return result;
        }

        const styleData = styleAttr.split(';').map(x => x.trim());
        styleData.forEach(sd => {
            const data = sd.split(':').map(x => x.trim());
            if (data.length === 2 && this.styles.includes(data[0])) {
                result.set(data[0], data[1]);
            }
        });

        return result;
    }
}